import { PdFormsAjaxArg } from '@/js/UI/naja/PdFormsAjaxValidationExtension'
import { HTMLFormFieldElement, Nette } from '../../validation'

export function emailValidator(elem: HTMLFormFieldElement, arg: PdFormsAjaxArg, val: string, value: string) {
	return Nette.validators.PdFormsRules_ajax(
		elem,
		arg,
		val,
		value,
		'AlbixonWebAppB2CModuleModelOrderDeliveryMailValidatorRule_validate'
	)
}
